import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
        name: 'urlFilter'
})
export class URLFilterPipe implements PipeTransform {
    transform(link: string) {
        var result;
        var startingUrl = "http://";
        var httpsStartingUrl = "https://"; 
        if(link.toString().startsWith(startingUrl)||link.toString().startsWith(httpsStartingUrl)){
            result = link;
        }
        else {
            result = startingUrl + link;
        }
        return result;
    }


   
}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/pipes/urlfilter-pipe.component.ts